/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiTraverser } from '../../visitors/AaiTraverser';

/**
 * @author eric.wittmann@gmail.com
 * @param {*} visitor
 * @class
 * @extends AaiTraverser
 */
export class Aai20Traverser extends AaiTraverser implements IAai20Visitor {
    public constructor(visitor : IAai20Visitor) {
        super(visitor);
    }
}
Aai20Traverser["__class"] = "io.apicurio.datamodels.asyncapi.v2.visitors.Aai20Traverser";
Aai20Traverser["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.core.visitors.ITraverser"];





import { IAai20Visitor } from './IAai20Visitor';

